import { render, staticRenderFns } from "./HandlerUserAdd.vue?vue&type=template&id=44ba10e8"
import script from "./HandlerUserAdd.vue?vue&type=script&lang=js"
export * from "./HandlerUserAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports